<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
// import echarts from 'echarts'
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "1200px",
    },
    height: {
      type: String,
      default: "350px",
    },
    chartData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      this.setOptions(this.chartData);
    },
    setOptions({ title, previousData, currentData, rateData } = {}) {
      this.chart.setOption({
        legend: { data: ["重点病种","重点学术"] },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: [0, 0.01],
            data: ["心血管外科","胸外科","神经外科","眼科","骨科","神经内科","消化内科","呼吸内科",],
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "重点病种",
            type: "bar",
            label: {
              show: true,
              position: 'top'
            },
            data: [6,5,6,4,5,3,5,6],
          },
          {
            name: "重点学术",
            type: "bar",
            label: {
              show: true,
              position: 'top',
              // formatter: (value, index)=>{
              //   console.log("value:",value.data);
              //   console.log("index:",value.dataIndex);
              //   console.log("rateData:",rateData);
              //   return value.data + "\n增长率"+ rateData[value.dataIndex]+"%";
              // },
            },
            data: [5,9,7,7,8,5,4,9]
          },
        ],
      });
    },
  },
};
</script>
